import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ChangePasswordDialogComponent } from 'app/change-password-dialog/change-password-dialog.component';
import { VerfyMailIDComponent } from 'app/profile-component/profile-component.component';
import { RestApiService } from 'app/shared/restApiServices/restapi.service';
import { ShowToastyService } from 'app/shared/services/showToastyService';
import { ImageCroppedEvent } from 'ngx-image-cropper';
declare var amplitude: any;

@Component({
  selector: 'app-update-basic-info',
  templateUrl: './update-basic-info.component.html',
  styleUrls: ['./update-basic-info.component.css']
})
export class UpdateBasicInfoComponent implements OnInit {

  
  updatedInfo = {'Name' : '' ,'email' : '' ,'phoneNo' : '', 'imageUrl' : '','companyName':''};
  userInfo;
  showManagerTab = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: 
  MatDialogRef<ChangePasswordDialogComponent>, private restApiService: RestApiService
  ,private dialog:MatDialog,private showToastyService:ShowToastyService) { 
    this.updatedInfo = data.updatedInfo;
    this.userInfo = data.userInfo;
    this.showManagerTab = data.showManagerTab;
  }

  ngOnInit() {
  }


  onSave(){
    amplitude.getInstance().logEvent('savebuttonisclickedinuserprofile');
    if(this.updatedInfo['Name'].length > 0 && this.updatedInfo['Name'].length > 0 && this.updatedInfo['Name'].length > 0)
    {
      if(this.updatedInfo['Name'] === this.userInfo['Name'])
      {
        this.updatedInfo['Name'] = null;
      }
      if(this.updatedInfo['email'] === this.userInfo['email'])
      {
        this.updatedInfo['email'] = null;
      }
      if(this.updatedInfo['phoneNo'] === this.userInfo['phoneNo'])
      {
        this.updatedInfo['phoneNo'] = null;
      }
      if(this.updatedInfo['companyName'] === this.userInfo['companyName'])
      {
        this.updatedInfo['companyName'] = null;
      }
      if(this.updatedInfo['imageUrl'] === this.userInfo['imageUrl'])
      {
        this.updatedInfo['imageUrl'] = null;
      }
      else{
        this.updatedInfo['imageUrl'] = this.updatedInfo['imageUrl'].replace(/^data:image\/[a-z]+;base64,/, "");
      }
      this.restApiService.updateUserInfo(this.updatedInfo['Name'],this.updatedInfo['email'],this.updatedInfo['phoneNo'], this.updatedInfo['imageUrl'],
      this.updatedInfo['companyName']).subscribe(res =>{
        if(res.success == true)
        {
          this.dialogRef.close(true);
          if(this.updatedInfo['email'] != null)
          {
            this.openVerficationModal();
          }
        }
        else
        {
          this.showToastyService.failure('Server error' ,"");
          this.dialogRef.close(false);
        }
      })
    }
  }


  openVerficationModal(){
    let dialogRef = this.dialog.open(VerfyMailIDComponent,{
      minWidth: '50rem',
      data: { email : this.userInfo['email']}
    })
    dialogRef.afterClosed().subscribe(res=>{
      if(res && res.success){
      }
    })
  }


  imageChangedEvent: any = '';
  editImage = false;
  oldImage;
  clicked($event){
    this.editImage = true;
    this.oldImage = this.updatedInfo.imageUrl;
    amplitude.getInstance().logEvent('choosefileclickedinuserprofile');
    this.imageChangedEvent = event;
    // var files = $event.srcElement.files;
    // var reader = new FileReader();
    // // read the image file as a data URL.
    // reader.readAsDataURL(files[0]);

    // reader.onload =  (e) => {
    //     // get loaded data and render thumbnail.
    //     let image_url = e.target['result'];
    //     this.updatedInfo['imageUrl']  = image_url;
    //     // this.updatedInfo['imageUrl'] = image_url.replace(/^data:image\/[a-z]+;base64,/, "");
    // };
  }
  imageCropped(event: ImageCroppedEvent) {
    this.updatedInfo['imageUrl']  = event.base64;
  }
  imageLoaded() {
      // show cropper
  }
  cropperReady() {
      // cropper ready
  }
  loadImageFailed() {
      // show message
  }

  closeDialog(){
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/update-basic-info/update-basic-info.component.ts